// extracted by mini-css-extract-plugin
module.exports = {"cta":"ArticleLink_cta__ru_6Y"};